<template>
    <div class="login-box">

      <div class="pay-popup flex-column flex-center">
        <div class="pay-window flex-column">
          <div class="top-tab flex flex-center">
            <div class="tab flex">
              <div
                class="tab-item flex flex-center"
                :class="accountType == 5 ? 'on' : ''"
                @click="selectTab(5)"
              >
                刷卡登录
              </div>
              <div
                class="tab-item flex flex-center"
                :class="accountType == 1 ? 'on' : ''"
                @click="selectTab(1)"
              >
                账号登录
              </div>
            </div>
          </div>
          <div class="form-data flex-column flex-center">
            <div
              class="form-item flex-column flex-center"
              v-if="accountType == 5"
            >
              <div class="item flex-column">
                <span>请刷员工卡</span>
                <input
                  type="text"
                  ref="cardInput"
                  v-model="accountName"
                  @keyup.enter="login"
                  placeholder="请刷员工卡"
                />
              </div>
            </div>
            <div
              class="form-item flex-column flex-center"
              v-if="accountType == 1"
            >
              <div class="item flex-column">
                <span>登录账号</span>
                <input
                  type="text"
                  ref="input"
                  v-model="accountName"
                  placeholder="请输入登录账号"
                />
              </div>
              <div class="item flex-column">
                <span>密码</span>
                <input
                  type="passWord"
                  v-model="password"
                  placeholder="请输入密码"
                />
              </div>
            </div>
          </div>
          <div class="btn-group flex-column flex-center">
            <blockquote>
              <div class="login flex flex-center" @click="login">登 录</div>
              <div class="cancel flex flex-center" @click="cancelBox">取消登录</div>
            </blockquote>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
export default {
  name: 'loginBox',
  props: {
  },
  data(){
    return {
      accountType: 5, // 账户类型（1:普通账号,2:手机号,3:邮箱,4: 微信OpenId,5:物理卡号,6: 苹果），默认1
      accountName: "",
      password: "",
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.$refs.cardInput.focus();
    });
  },
  methods:{
    // tab栏点击
    selectTab(index) {
      this.accountType = index;
      if (index == 5) {
        this.$nextTick(() => {
          this.$refs.cardInput.focus();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      }
    },
    login() {
      let data = {
        accountName: this.accountName,
        accountType: this.accountType,
        password: this.password,
        tenantIdOrStoreId: localStorage.getItem("storeId"),
      };
      if (this.accountType == 5) {
        if (this.accountName == "") {
          this.$toast("请刷员工卡");
          return false;
        }
      } else {
        if (this.accountName == "") {
          this.$toast("请输入账号");
          return false;
        }
        if (this.password == "") {
          this.$toast("请输入密码");
          return false;
        }
      }
      this.$post(this.Api.LoginApi, data).then((res) => {
        if (res.code == 1) {
          if (res.data.length > 0) {
            this.$emit('login',res.data[0].token)
          }
        }
      });
    },
    cancelBox() {
      this.accountType = 5; // 账户类型（1:普通账号,2:手机号,3:邮箱,4: 微信OpenId,5:物理卡号,6: 苹果），默认1
      this.$emit('cancel')
    },
  }
}
</script>


<style lang="less" scoped>
.login-box{
  .pay-popup {
    width: 100%;
    height: 100vh;
    position: absolute;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.6);
    .pay-window {
      width: 996px;
      height: 1120px;
      background-color: #fff;
      border-radius: 32px;
      box-sizing: border-box;
      .top-tab {
        width: 100%;
        box-sizing: border-box;
        padding-top: 64px;
        .tab {
          width: 686px;
          height: 140px;
          .tab-item {
            border: 4px solid #dadde1;
            flex: 1;
            font-size: 44px;
            color: #666666;
            font-weight: 500;
            &:first-child {
              border-right: 0;
              border-top-left-radius: 15px;
              border-bottom-left-radius: 15px;
            }
            &:last-child {
              border-left: 0;
              border-top-right-radius: 15px;
              border-bottom-right-radius: 15px;
            }
            &.on {
              color: #fff;
              background-color: #007aff;
            }
          }
        }
      }
      .form-data {
        width: 100%;
        box-sizing: border-box;
        flex: 1;
        padding: 0 155px;
        .form-item {
          width: 100%;
          height: 100%;
          .item {
            width: 100%;
            margin-bottom: 56px;
            &:last-child {
              margin-bottom: 0;
            }
            span {
              font-size: 44px;
              line-height: 64px;
              font-size: #1a1e22;
              margin-bottom: 32px;
            }
            input,
            select {
              width: 100%;
              height: 140px;
              background: #f4f4f4;
              box-shadow: inset 2px 4px 4px rgba(0, 0, 0, 0.25);
              border-radius: 16px;
              font-size: 44px;
              text-indent: 32px;
              color: #1a1e22;
              border: 0;
              &::placeholder {
                color: #b9bdc6;
              }
            }
            .number {
              margin-top: 30px;
              img {
                width: 88px;
                height: 88px;
              }
              .num {
                width: 142px;
                font-size: 66px;
                color: #333;
                font-weight: 700;
                text-align: center;
              }
            }
          }
        }
      }
      .btn-group {
        width: 100%;
        box-sizing: border-box;
        .login {
          width: 686px;
          height: 140px;
          background: #155bd4;
          border-radius: 16px;
          font-size: 40px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 10px;
        }
        .cancel {
          width: 686px;
          height: 140px;
          font-size: 40px;
          font-weight: 700;
          color: #155bd4;
        }
      }
    }
  }
}
</style>
